<!-- Badge de "Agotado" -->
<div
  *ngIf="product.show_in_store && !product.active"
  class="w-2/6 absolute top-0 left-0 bg-secondary text-black text-center font-bold py-2 cursor-not-allowed"
>
  Agotado
</div>

<!-- Badge de descuento -->
<div
  *ngIf="product.discount"
  class="absolute top-10 right-0 bg-primary text-white font-bold text-center py-2 px-3 cursor-not-allowed"
>
  <ng-container *ngIf="product.discount.type === 'percent'">
    {{ product.discount.value }}% DESCUENTO
  </ng-container>
  <ng-container *ngIf="product.discount.type === 'amount'">
    -{{ product.discount.value | customCurrency }} MENOS
  </ng-container>
</div>
